var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewAdDetauls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.6875C8.8125 19.6875 8.8125 10.3125 15 10.3125C21.1172 10.3125 21.3816 19.6875 15 19.6875ZM15 12.1875C11.25 12.1875 11.25 17.8125 15 17.8125C18.75 17.8125 18.75 12.1875 15 12.1875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 23.4375C10.3604 23.4375 5.91758 20.9728 2.81258 16.6744C2.4596 16.1874 2.26953 15.6014 2.26953 15C2.26953 14.3986 2.4596 13.8126 2.81258 13.3256C5.91758 9.02719 10.3604 6.5625 15.0001 6.5625C19.6398 6.5625 24.0826 9.02719 27.1876 13.3256C27.5406 13.8126 27.7306 14.3986 27.7306 15C27.7306 15.6014 27.5406 16.1874 27.1876 16.6744C24.0826 20.9728 19.6398 23.4375 15.0001 23.4375ZM4.32852 15.5756C7.12039 19.4363 10.9098 21.5625 15.0001 21.5625C19.0904 21.5625 22.8798 19.4363 25.6716 15.5756C25.7931 15.4081 25.8585 15.2065 25.8585 14.9995C25.8585 14.7926 25.7931 14.591 25.6716 14.4234C22.8798 10.5638 19.0904 8.4375 15.0001 8.4375C10.9098 8.4375 7.12039 10.5637 4.32852 14.4244C4.20707 14.5919 4.14168 14.7935 4.14168 15.0005C4.14168 15.2074 4.20707 15.4081 4.32852 15.5756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAdDetauls);
export default __webpack_public_path__ + "static/media/view_ad_detauls.101ca072ebb38932508da66d54649143.svg";
export { ForwardRef as ReactComponent };